// Base ladder rate (600 points = $10), used only for estimates. Actual redemption value comes from
// the redemption tiers (GET /rewards/tiers), which improve to 2c/point at 15,000 points.
export const POINTS_PER_DOLLAR = 60;

export const pointsToDollars = (points) => {
	const value = Number(points);
	if (!value || value < 0) return 0;
	return value / POINTS_PER_DOLLAR;
};

export const formatDollars = (points) => {
	const dollars = pointsToDollars(points);
	return `$${Number.isInteger(dollars) ? dollars : dollars.toFixed(2)}`;
};

export const formatPoints = (points) => `${Number(points || 0).toLocaleString()} ${Number(points) === 1 ? "Point" : "Points"}`;
